import { render, staticRenderFns } from "./HotelFloorShare.vue?vue&type=template&id=b5457024"
import script from "./HotelFloorShare.vue?vue&type=script&lang=js"
export * from "./HotelFloorShare.vue?vue&type=script&lang=js"
import style0 from "./HotelFloorShare.vue?vue&type=style&index=0&id=b5457024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports